import React, { useState, useMemo } from 'react';

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner
} from 'reactstrap';

import WorkflowRequirementStageForm from './form';

const aasmStateEventConfig = (event) => {
  if (event === 'to_proceeded') {
    return { style: 'success', icon: 'check-circle' };
  } else if (event === 'to_completed') {
    return { style: 'success', icon: 'clipboard-check' };
  } else if (event === 'to_returned') {
    return { style: 'warning', icon: 'undo' };
  } else if (event === 'to_rejected') {
    return { style: 'danger', icon: 'ban' };
  }
  return { style: 'secondary', icon: 'question-circle' };
};

const WorkflowRequirementStageToolbarEvent = (props) => {
  const {
    policies: {
      canEdit: policyCanEdit
    },
  } = props;

  const [requirementStage, setRequirementStage] = useState(props?.requirementStage);
  const [modalOpen, setModalOpen] = useState(false);

  const onSuccessSubmit = (routes, defaultRequestRequirementParams) => {
    setModalOpen(false);
    if (routes?.showRequirementPath && defaultRequestRequirementParams) {
      window.location = routes.showRequirementPath({ ...defaultRequestRequirementParams, _options: true });
    } else {
      window.location.reload();
    }
  };

  const onChangeRequirementStage = (key, value) => {
    setRequirementStage(prevState => ({
      ...prevState,
      [key]: value
    }));
  };

  const openModal = (aasmEvent) => {
    onChangeRequirementStage('aasm_state_event', aasmEvent);
    setModalOpen(true);
  };

  const closeModal = () => {
    onChangeRequirementStage('aasm_state_event', null);
    setModalOpen(false);
  };

  const renderEventButtons = () => {
    if (requirementStage?.events?.permitted && policyCanEdit) {
      return requirementStage.events.permitted.map(permittedEvent => {
        const config = aasmStateEventConfig(permittedEvent.event);
        return (
          <Button
            key={`EventButton-${permittedEvent.event}`}
            className="ms-1"
            outline
            color={config.style}
            size="sm"
            onClick={() => openModal(permittedEvent.event)}
          >
            <i className={`fas fa-${config.icon}`}></i> {permittedEvent.human_name}
          </Button>
        );
      });
    }
    return null;
  };

  const aasmEventToHumanName = useMemo(() => {

    const event = _.find(props.requirementStage.events.permitted, { event: props.requirementStage.aasm_state_event });

    return event?.human_name;
  }, [props.requirementStage.aasm_state_event])

  const modalTitle = () => {
    const eventHumanName = aasmEventToHumanName;
    const stageName = props.requirementStage.stage_name;

    let title = '';

    if (eventHumanName) {
      title = `${eventHumanName} - `
    }

    title = title + stageName;
    return title;
  }

  return (
    <>
      <div className="d-flex justify-content-end mb-2">
        {renderEventButtons()}
      </div>

      <Modal isOpen={modalOpen} toggle={closeModal} size="lg">
        <ModalHeader toggle={closeModal}>
          {modalTitle()}
        </ModalHeader>

        <ModalBody>
          <WorkflowRequirementStageForm
            requirementStage={requirementStage}
            policies={props.policies}
            configuration={props.configuration}
            currentEntityType={props.currentEntityType }
            showNextStageAttributes={true}
            onSuccessSubmit={onSuccessSubmit}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default WorkflowRequirementStageToolbarEvent;
